import React, { Suspense, useEffect, useState } from 'react'
import Navbar from '../../Components/Gerneralcomponents/Navbar/Navbar'
import Addhelp from '../../Components/Gerneralcomponents/Helpcomp/Addhelp'
import Footer from '../../Components/Gerneralcomponents/Footer/footer'

import { showDataNoToken } from '../../Components/service/Contrato/showData'
import Iconos from '../configEmpresarial'
import { Box } from 'iconoir-react'
import SliderCases from './SliderCases'
// const Spline = React.lazy(() => import('@splinetool/react-spline'));

const LandingProduct = () => {
    const [ServiceEmp, setServiceEmp] = useState([]);


    const obtenerDatos = async () => {
        try {
            const datoSer = await showDataNoToken('GET', `/empresarial/servicios/`);
            setServiceEmp(datoSer.data);
        } catch (error) {
            console.error('Error al obtener datos:', error);
        }
    };

    useEffect(() => {
        obtenerDatos();
    }, []);
    return (
        < >
            <title>Emcali Internet - Servicios de Fibra Óptica</title>
            <meta name="description" content="Descubre los servicios de internet por fibra óptica de Emcali, con las mejores velocidades y precios en el mercado." />
            <meta property="og:title" content="Emcali Internet - Servicios de Fibra Óptica" />
            <meta property="og:description" content="Descubre los servicios de internet por fibra óptica de Emcali, con las mejores velocidades y precios en el mercado." />
            <meta property="og:url" content="https://portalservicios.emcali.net.co/Empresarial" />
            <meta property="og:type" content="website" />
            <meta name="keywords" content="Emcali, Emcali Internet, Internet, Fibra optica, Cali, Jamundi, Yumbo" />
            <div>
                <Navbar />
                <header>
                    <h1>Servicios de Internet por Fibra Óptica de Emcali</h1>
                </header>
                <main>
                    <Navbar />
                    <div className="h-16 " />
                    <div>
                        <div className='absolute flex justify-center items-center w-full min-h-screen flex-col  gap-3 text-white'>

                            <h2 className='text-6xl font-bold tracking-tight text-gray-100 sm:text-9xl  max-md:px-64  mt-64' >EMCALI </h2>
                            <h2 className='text-xl font-bold tracking-tight text-gray-200 sm:text-5xl  max-md:px-64 px-0'>Lo que tu negocio necesita</h2>
                            <p className="text-gray-300 mt-2 text-lg md:flex justify-start text-center lg:px-[20rem] 2xl:px-[32rem] px-6 hidden">Conectamos tu negocio con el futuro. En Emcali, ofrecemos soluciones integrales en telecomunicaciones y tecnología diseñadas para impulsar el crecimiento de tu empresa, sin importar el tamaño o sector. Desde la agilidad de AWS Cloud hasta la confiabilidad de nuestros Data Centers locales, estamos listos para cubrir todas tus necesidades de conectividad, almacenamiento y comunicación empresarial.</p>
                            <div className='flex w-full items-center justify-center gap-2  mt-2'>
                                <a href='/SelBuyEmpresarial' className=" py-2 px-2 border border-transparent rounded-md shadow-sm text-xl font-bold text-gray-800 bg-white no-underline w-52 h-12 flex justify-center items-center hover:text-violet-700 ">Solicitar servicio</a>
                            </div>
                            <div className='flex flex-col justify-center items-center '>
                                <p className='text-gray-300 mt-2 text-lg text-centerg'>
                                    ¡Contrata tu Plan empresarial llamando al 6028998181!
                                </p>
                            </div>
                        </div>
                        {/* <Spline className='min-h-screen' scene="https://prod.spline.design/jyvBRY1myPXJl3mv/scene.splinecode" /> */}
                        {/* <Suspense fallback={<div>Loading...</div>}>
                            <Spline scene="https://my.spline.design/ipadandapplepencilshowcase-24994738613e7d52bde51731c73ba677/" />
                        </Suspense> */}
                        {/* <Spline className='min-h-screen' scene="https://my.spline.design/flippingworkdesk-0524711c12d22111ce11c4734bdc318f/" /> */}
                    </div>
                    <a className="fixed bg-red-500 rounded-xl text-white p-6 h-8 w-24 hover:bg-red-600 z-50 bottom-0 right-0 m-6 flex justify-center items-center" href="/Ayuda">Ayuda?</a>

                    <div >
                        <div className="flex  justify-center items-center mt-10">
                            <div className="flex   flex-col   gap-1 ">
                                <h2 className="text-4xl font-bold tracking-tight text-gray-800 sm:text-4xl flex justify-center">Servicios</h2>
                                <div>
                                    <div className='flex flex-wrap justify-center gap-12 my-8 w-full '>
                                        {ServiceEmp.map((items) => {
                                            return (
                                                <div key={items.id} className="" >
                                                    <a href='/' className=" flex flex-col justify-center items-center no-underline shadow-xl h-48 w-80 lg:w-56  my-10 bg-violet-900 text-white text-2xl rounded-md hover:text-violet-500" type="submit" > {Iconos[0].Config?.find(config => config.id === items.codigo)?.icon || <Box />}{items.nombre}</a>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="flex  justify-center items-center mt-10">
                            <div className="flex   flex-col   gap-1 ">
                                <h2 className="text-4xl font-bold tracking-tight text-gray-800 sm:text-4xl flex justify-center">Casos de exito</h2>
                                <div className=''>
                                    <SliderCases />
                                </div>
                            </div>
                        </div>
                    </div>
                    <Addhelp />
                </main>
                <footer>
                    <Footer />
                </footer>
            </div>
        </>
    )
}
export default LandingProduct;

